// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__LABKn","live":"StatusBadge_live__K1HGz","test":"StatusBadge_test__j1P9X"};